var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6728 25.2959C19.689 24.9396 18.8501 24.4785 18.1893 24.0461C16.7401 24.6066 15.1566 24.9149 13.5 24.9149C6.59644 24.9149 1 19.5703 1 12.9775C1 6.3846 6.59644 1.04004 13.5 1.04004C20.4035 1.04004 26 6.3846 26 12.9775C26 15.4505 25.2114 17.7506 23.8612 19.6571C23.7756 21.2335 24.6425 22.6578 25.5423 23.9182C26.3303 25.022 26.1326 25.9115 24.6632 25.9911C24.0045 26.0267 22.5799 25.9864 20.6728 25.2959ZM3.27273 12.9775C3.27273 7.5833 7.85164 3.21048 13.5 3.21048C19.1484 3.21048 23.7273 7.5833 23.7273 12.9775C23.7273 15.094 23.0236 17.0504 21.8273 18.649C21.298 19.3566 21.5702 20.6823 21.7518 21.4434C21.9281 22.1821 22.3105 22.967 22.6882 23.626C22.3266 23.5427 21.9217 23.4268 21.4786 23.2664C20.459 22.8971 19.6164 22.3781 19.022 21.9424C18.6848 21.6952 18.2312 21.6486 17.8466 21.8213C16.5289 22.4131 15.0565 22.7444 13.5 22.7444C7.85164 22.7444 3.27273 18.3716 3.27273 12.9775ZM8.98865 16.4963C8.81168 15.8203 9.37067 15.1481 10.0911 15.1477H16.9093C17.6287 15.1481 18.1886 15.8177 18.0117 16.4936C17.4233 18.3906 15.5289 19.4888 13.5002 19.4888C11.5493 19.4888 9.48752 18.402 8.98865 16.4963ZM18.6136 10.807C18.6136 11.706 17.8505 12.4348 16.9091 12.4348C15.9677 12.4348 15.2045 11.706 15.2045 10.807C15.2045 9.90799 15.9677 9.17919 16.9091 9.17919C17.8505 9.17919 18.6136 9.90799 18.6136 10.807ZM10.0909 12.4348C11.0323 12.4348 11.7955 11.706 11.7955 10.807C11.7955 9.90799 11.0323 9.17919 10.0909 9.17919C9.14951 9.17919 8.38636 9.90799 8.38636 10.807C8.38636 11.706 9.14951 12.4348 10.0909 12.4348Z",
    fill: "url(#paint0_linear_8473_33286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8473_33286",
    x1: 1,
    y1: 13.52,
    x2: 26,
    y2: 13.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconBottom);
export default __webpack_public_path__ + "static/media/ChatIconBottom.1b300fcd997badbf194643099b41e771.svg";
export { ForwardRef as ReactComponent };